// Module
var code = "<file-browser-tab\n  root-folder-id=\"vm.rootFolderId\"\n  is-article=\"vm.isArticle\"\n></file-browser-tab>\n";
// Exports
module.exports = code;